module.exports = __webpack_public_path__ + "static/media/Deli_Wrong.ae2362b4.svg";